<template>
	<v-container fluid>
		<v-snackbar 
			top
			left
			v-for="(item, key) of list"
			:key="'snackTechnicalKey'+ key"
			v-model="item.snack"
			:timeout="item.timeout || -1"		
			:id="'snackTechnical'+key"
			class="v_snack_size  ma-0 "
			:style="`top: ${(key * 50)}px;`"
			v-if="false && key < 8 && $route.name.includes('dashboard')"
			:color ="item.color || 'warning'"
        	style             = "z-index: 100;"

		>							
			<v-row no-gutters justify="center" align="center">
				<v-col cols ="1">
					<v-icon>{{item.icon}}</v-icon>
				</v-col>
				<v-col cols ="10">
					{{ item.name }} : {{ item.text }}
				</v-col>
				<v-col cols ="1" ><v-icon color="white" dark @click="closeSnack(item,key)">mdi-close-circle</v-icon></v-col>
			</v-row>
		</v-snackbar>
	</v-container>
</template>
<style type="text/css"  scoped="scoped">
	.v_snack_size >>> .v-snack__wrapper{
/*		min-width: 220px;*/
		width: 220px;		
	}
	
	.v_snack_size >>> .v-snack__content {
	 	padding: 1px;
	}
	.v-snack__content {
		padding: 1px;
		

	}
</style>
<script type="text/javascript">
	export default {
		name : "NotificationTechnicals",
		data : ()=>({
			list : [ 
				/*{snack : true, icon  : "mdi-account", text : "testing asdasdasdasdsadasd asdasd asd asd sad asdasd da sdasd sa"}, 
				{snack : true, icon  : "mdi-account", text : "testing asdasdasdasdsadasd asdasd asd asd sad asdasd da sdasd sa"}*/
			],
			bus : {},
		}), // data
		methods :{
			actionTechnical(item){
				if (item) {
					const idx = this.list.findIndex(x => x && x.deviceId == item.deviceId && x.code.includes(item.code.substring(0,6)));
					let newInfo = {
						icon : "mdi-cctv",
						text : "",
						snack : true,
						timeout : -1,
					};
					newInfo = this.formatTechnical(item,newInfo);
					if (idx>=0) {
						this.list.splice(idx,1,newInfo);
					}else{
						this.list.unshift(newInfo);
					}
				}
			},
			formatTechnical(item, newInfo){
				if (item.icon || item.icon_code) {
					newInfo.icon = item.icon || item.icon_code;
				}
				if (item.color) {
					newInfo.color = item.color
				}
				if (item.device || item.name) {
					newInfo.name = item.device || item.name; 
				}
				if (item.code) {
					newInfo.text = this.$ml.get(item.code);
					newInfo.code = item.code;
				}
				if (item.state == 0) {
					newInfo.timeout = 3000;							
				}
				return newInfo;
			}, 
			closeSnack(item,idx){
				if (idx >=0) {
					this.list.splice(idx,1);
				}
			},
		}, // methods
		mounted(){
			this.$EventBus.$on("NotificationTechnicals", this.bus["NotificationTechnicals"]=(msg)=>{
				this.actionTechnical(msg);
			});
		}, // mounted
		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, "NotificationTechnicals");
		}, // beforeDestroy
	};
</script>